<template>
    <div>
        <div v-for="(comment, index) in comments" :key="index">
            <p><strong>{{comment.date | moment('DD/MM/YYYY') }} - {{comment.author}}</strong></p>
            <p>{{comment.content}}</p>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        comments: {
            type: Array,
            required: true,
        },
    },

    data () {
        return {

        };
    }
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/Home/comments.vue